<template>
  <div class="section">
    <div class="columns">
      <a href="https://www.betrefs.com" target="_blank" class="column banner-holder">
        <div class="banner"></div>
      </a>
      <div class="home column">
        <div class="tile is-ancestor">
          <div class="tile is-parent">
            <Music/>
          </div>
          <div class="tile is-parent is-vertical">
            <SteamGroup/>
            <Discord/>
          </div>
        </div>
        <div class="tile is-ancestor">
          <div class="tile is-vertical is-8">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <SocialMedia/>
              </div>
              <div class="tile is-parent">
                <Config/>
              </div>
            </div>
          </div>
          <div class="tile is-parent">
            <Clothing/>
          </div>
        </div>

        <div class="tile is-ancestor">
          <div class="tile is-parent">
            <FAQ/>
          </div>
          <div class="tile is-parent is-8">
            <Setup/>
          </div>
        </div>
      </div>
      <a href="https://www.betrefs.com" target="_blank" class="column banner-holder">
        <div class="banner"></div>
      </a>
    </div>   
  </div>
</template>

<script>
import Music from '../components/Music'
import FAQ from '../components/FAQ'
import SocialMedia from '../components/SocialMedia'
import SteamGroup from '../components/SteamGroup'
import Config from '../components/Config'
import Clothing from '../components/Clothing'
import Setup from '../components/Setup'
import Discord from '../components/Discord'

export default {
  name: 'home',
  components: {
    Music,
    FAQ,
    SocialMedia,
    SteamGroup,
    Config,
    Clothing,
    Setup,
    Discord
  }
}
</script>

<style lang="scss">
.home {
  padding: 1em;
}

.banner-holder {
  max-width: 300px !important;
  padding: 1em;
  .banner {
    background-image: url('../assets/Betrefs_sidepanel.png');
    background-repeat: no-repeat;
    background-position: top center;
    width: 100%;
    height: 100%;
  }
}

.t-box {
  background: #151515;
  padding: 1rem;
  border: 1px solid white;
  -webkit-box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);   
}

@media only screen and (max-width: 1400px) {
  .banner-holder {
    display: none !important;
  }
}
</style>
